// extracted by css-extract-rspack-plugin
export default {"featuredGrid":"Playground-module__featuredGrid__AOAhS"};